import React from 'react';
import { Icon, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

const dataOverviewColumns = [
  {
    title: '产品名称',
    dataIndex: 'productName',
    key: 'productName',
  },
  {
    title: '产品规模',
    dataIndex: 'requestAmount',
    key: 'requestAmount',
  },
  {
    title: '资产笔数',
    dataIndex: 'assetCount',
    key: 'assetCount',
  },
  {
    title: '受让资产价值',
    dataIndex: 'remainingValue',
    key: 'remainingValue',
  },
  {
    title: '平均首付金额',
    dataIndex: 'downpayAmount',
    key: 'downpayAmount',
  },
  {
    title: '平均首付比例（%）',
    dataIndex: 'downpayRate',
    key: 'downpayRate',
  },
  {
    title: '厂商指导价合计',
    dataIndex: 'guidePrice',
    key: 'guidePrice',
  },
  {
    title: '尾款合计',
    dataIndex: 'finalRepayAmount',
    key: 'finalRepayAmount',
  },
  {
    title: '平均尾款',
    dataIndex: 'avgFinalRepayAmount',
    key: 'avgFinalRepayAmount',
  },
  {
    title: '未偿租金合计',
    dataIndex: 'notRent',
    key: 'notRent',
  },
  {
    title: '未偿尾款合计',
    dataIndex: 'notFinalRepayAmount',
    key: 'notFinalRepayAmount',
  },
  {
    title: '当前逾期笔数',
    dataIndex: 'oveDueCount',
    key: 'oveDueCount',
  },
  {
    title: '产品详情',
    dataIndex: 'financingNo',
    key: 'financingNo',
    render: (record) => {
      return <Link
        to={
          {
            pathname: `/assetModule/dataOverview/details`,
            state: { financingNo: record }
          }
        }>
        详情
             </Link >
    }
  },
];

const dataOverviewColumns2 = [
  {
    title: '产品名称',
    dataIndex: 'productName',
    key: 'productName',
  },
  {
    title: '产品笔数',
    dataIndex: 'productCount',
    key: 'productCount',
  },
  {
    title: '逾期31-60天',
    dataIndex: '',
    key: 'expirationCount3060',
    render: (record) => {
      return <Link
        to={
          {
            pathname: `/assetModule/dataOverview/quality`,
            state: { financingNo: record.financingNo, start: '31', end: '60' }
          }
        }>
        {record.expirationCount3060}
        </Link >
    }
  },
  {
    title: '逾期61-90天',
    dataIndex: '',
    key: 'expirationCount6090',
    render: (record) => {
      return <Link
        to={
          {
            pathname: `/assetModule/dataOverview/quality`,
            state: { financingNo: record.financingNo, start: '61', end: '90' }
          }
        }>
        {record.expirationCount6090}
             </Link >
    }
  },
  {
    title: '逾期91天以上',
    dataIndex: '',
    key: 'expirationCount90',
    render: (record) => {
      return <Link
        to={
          {
            pathname: `/assetModule/dataOverview/quality`,
            state: { financingNo: record.financingNo, start: '90' }
          }
        }>
        {record.expirationCount90}
             </Link >
    }
  },
  {
    title: '笔数小记',
    dataIndex: 'expirationCount30',
    key: 'expirationCount30',
  },
  {
    title: '金额小记',
    dataIndex: 'lateFee',
    key: 'lateFee',
  },
  {
    title: (<div>
      <span style={{ paddingRight: 10 }}>逾期率 （%）</span>
      <Tooltip placement="top" title={'逾期率=30天以上的逾期笔数/总笔数'}>
        <Icon type="question-circle" />
      </Tooltip>
    </div>),
    dataIndex: 'overdueRate30',
    key: 'overdueRate30',
  },
];

const repayment = [
  {
    title: '还款期数',
    dataIndex: 'position',
    key: 'position',
  },
  {
    title: '应还日期',
    dataIndex: 'expiredAt',
    key: 'expiredAt',
  },
  {
    title: '实还日期',
    dataIndex: 'repayAt',
    key: 'repayAt',
  },
  {
    title: '逾期天数',
    dataIndex: 'lateDays',
    key: 'lateDays',
    render: (record) => {
      return record !== 0 && record !== '0' ? <span style={{color: 'red'}}>{record}</span> : record
    }
  },
  {
    title: '实还金额',
    dataIndex: '',
    key: 'amount',
    render: (record) => {
      return record.lateDays !== 0 && record.lateDays !== '0' ? <span style={{color: 'red'}}>{record.amount}</span> : record.amount
    }
  },
  {
    title: '应还月供',
    dataIndex: 'principalAndInterestAmount',
    key: 'principalAndInterestAmount',
  },
  {
    title: '滞纳金',
    dataIndex: 'lateFee',
    key: 'lateFee',
    render: (record) => {
      return <span style={{color: 'red'}}>{record}</span>
    }
  },
  {
    title: '还款方式',
    dataIndex: 'payChannel',
    key: 'payChannel',
    // render: (record) => {
    //   switch (record) {
    //     case 'ALIPAY':
    //       return '支付宝还款'
    //     case 'MYBANK':
    //       return '网商代扣'
    //     case 'OFF_LINE':
    //       return '线下还款'
    //     case 'ADVANCE':
    //       return '提前结'
    //     default:
    //       return '暂无数据'
    //   }
    // }
  },
  {
    title: '还款状态',
    dataIndex: 'success',
    key: 'success',
    render: (record) => {
      switch (record) {
        case '已结清':
          return <span style={{color: 'rgb(76, 214, 86)'}}>{record}</span>
        case '正常':
          return record
        case '逾期':
          return <span style={{color: 'red'}}>{record}</span>
        default:
          return '暂无数据'
      }
    }
  }
]

const customer = [
  {
    title: '客户姓名',
    dataIndex: 'customName',
    key: 'customName',
  },
  {
    title: '身份证号码',
    dataIndex: 'idNo',
    key: 'idNo',
  },
  {
    title: '手机号码',
    dataIndex: 'phoneNo',
    key: 'phoneNo',
  }
]

const contract = [
  {
    title: '首付支付日',
    dataIndex: 'downpayDate',
    key: 'downpayDate',
  },
  {
    title: '提车日',
    dataIndex: 'pickCarDate',
    key: 'pickCarDate',
  },
  // {
  //   title: '还款日',
  //   dataIndex: 'downpayDate',
  //   key: 'downpayDate',
  // },
  {
    title: '租约开始日',
    dataIndex: 'contractStart',
    key: 'contractStart',
  },
  {
    title: '租约结束日',
    dataIndex: 'contractEnd',
    key: 'contractEnd',
  }
]

const programme = [
  {
    title: '指导价',
    dataIndex: 'guidePrice',
    key: 'guidePrice',
  },
  {
    title: '首付金额',
    dataIndex: 'downpayAmount',
    key: 'downpayAmount',
  },
  {
    title: '首付比例',
    dataIndex: 'downpayRate',
    key: 'downpayRate',
  },
  {
    title: '月供金额',
    dataIndex: 'nominalInstallmentAmount',
    key: 'nominalInstallmentAmount',
  },
  {
    title: '尾款比例',
    dataIndex: 'finalRepayRate',
    key: 'finalRepayRate',
  },
  {
    title: '参考利率',
    dataIndex: 'executiveRate',
    key: 'executiveRate',
  }
]

const car = [
  {
    title: '车牌号',
    dataIndex: 'plateNo',
    key: 'plateNo',
  },
  {
    title: '车架号',
    dataIndex: 'vinNo',
    key: 'vinNo',
  },
  {
    title: '上牌省市',
    dataIndex: 'storeCity',
    key: 'storeCity',
  },
  // {
  //   title: '登记人',
  //   dataIndex: 'repayAt2',
  //   key: 'repayAt2',
  // },
  {
    title: '车型',
    dataIndex: 'carType',
    key: 'carType',
  },
  {
    title: '车系',
    dataIndex: 'series',
    key: 'series',
  },
  // {
  //   title: '车辆是否在线',
  //   dataIndex: 'repayAt5',
  //   key: 'repayAt5',
  // }
]

const insurance = [
  {
    title: '商业保险公司名称',
    dataIndex: 'businessInsuranceCompany',
    key: 'businessInsuranceCompany',
  },
  {
    title: '商业保险单号',
    dataIndex: 'businessInsuranceNo',
    key: 'businessInsuranceNo',
  },
  {
    title: '交强保险公司名称',
    dataIndex: 'compulsorylnsuranceCompany',
    key: 'compulsorylnsuranceCompany',
  },
  {
    title: '交强险保单号',
    dataIndex: 'compulsorylnsuranceNo',
    key: 'compulsorylnsuranceNo',
  }
]

const GPS = [
  {
    title: 'GPS1供应商',
    dataIndex: 'gpsSourceOrg',
    key: 'gpsSourceOrg',
  },
  {
    title: 'GPS1代码',
    dataIndex: 'gpsSourceCode',
    key: 'gpsSourceCode',
  },
  {
    title: 'GPS2供应商',
    dataIndex: 'gpsNonSourceOrg',
    key: 'gpsNonSourceOrg',
  },
  {
    title: 'GPS2代码',
    dataIndex: 'gpsNonSourceCode',
    key: 'gpsNonSourceCode',
  }
]

export default {
  dataOverviewColumns,
  dataOverviewColumns2,
  repayment,
  customer,
  contract,
  programme,
  car,
  insurance,
  GPS
}